module.exports = __webpack_public_path__ + "static/media/institutions-icon-4.b84a31e2.svg";